export const getUseProductionServer = (): boolean => {
    const value = import.meta.env.VITE_USE_PRODUCTION_SERVER;
    if (value === undefined) {
        return true;
    }
    return value === "true";
};
